import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import {useStoreState, useStoreActions} from 'easy-peasy';
import { Col, Container,  Alert,  Row, ToggleButton, ToggleButtonGroup, Button } from 'react-bootstrap';

import PackageTableComponent from '../../components/packages/PackageTableComponent';
import PackageBoardComponent from '../../components/packages/PackageBoardComponent';

import Loader from "../../components/widgets/Loader";
import AuthorizationChecker from '../../services/AuthorizationChecker';
import useCustomGetStoreState from '../../hooks/useCustomGetStoreState';
import useSearchWithParams from '../../hooks/useSearchWithParams';
import HelperMetiers360 from '../../services/HelpersMetiers360';

const PackagePage = () => {

    const {allPackages, isFetchingAllPackages} = useCustomGetStoreState('packages');

    const packagesSlugs = useStoreState(state => state.actionSlugs.actionSlugsDispatcher("packages"));

    const viewStylePreference = useStoreState(state => state.preferences.packageListStyle);
    const setViewStylePreference = useStoreActions(actions => actions.preferences.setPackageListStyle);

    const packageBoardSortType = useStoreState(state => state.preferences.packageBoardSortType);
    const setPackageBoardSortType = useStoreActions(actions => actions.preferences.setPackageBoardSortType);


    const [filteredPackages, setFilteredPackages] = useState(allPackages);

    const viewStyleType = [
        {value : 'cards', label:<><i className="fas fa-address-card"></i></>, view : <PackageBoardComponent packages = {filteredPackages} sortTypePreferenceTuple={[packageBoardSortType, setPackageBoardSortType]} {...packagesSlugs} />},
        { value: 'table', label: <><i className="fas fa-table"></i></>, view: <PackageTableComponent packages={filteredPackages} {...packagesSlugs} /> },
    ];

    const [viewStyle, setViewStyle] = useState(viewStylePreference);

    const handleChange = (val) => {        
        setViewStyle(val);
        setViewStylePreference(val);
    }

    const checkViewStyle = viewStyleType.map(
        type => <ToggleButton value={type.value} key={type.value} id={type.value} checked={type.value == viewStyle}>{type.label}</ToggleButton>
    );


    const createPackageButton = packagesSlugs.create
        ? <Button variant="success" as={Link} to={packagesSlugs.create? packagesSlugs.create : ""}><i className="fas fa-plus"></i> &nbsp;Nouveau</Button>
        : null;

    useEffect(() => {
        setFilteredPackages(allPackages);
    }, [allPackages])

    const { searchInput, search } = useSearchWithParams({ placeholder: 'Rechercher par mots-clés', delay: 400 })

    useEffect(() => {
        setFilteredPackages(
            allPackages.filter(pkg =>
                HelperMetiers360.isSearchInText(search, pkg.name) ||
                HelperMetiers360.isSearchInText(search, pkg.description)
            )
        );
    }, [search, allPackages]);
    

    const isNoPackage = !isFetchingAllPackages && !allPackages.length
    const isNoResult = !isFetchingAllPackages && allPackages.length && !filteredPackages.length;

    return <Container fluid>
        <Row>
            <Col>
                <h2 className="d-flex">
                    Applications casque
                </h2>
            </Col>
        </Row>
        <Row className="item-page">
            <Col>
                {searchInput}
            </Col>
            <Col className='col-auto'>
                <ToggleButtonGroup type="radio" name="option-view-packages" value={viewStyle} onChange={handleChange}>
                    {checkViewStyle}
                </ToggleButtonGroup>
            </Col>
            <Col className='col-auto'>
                {AuthorizationChecker.hasCreateRights('packages') ? createPackageButton : ""}
            </Col>
        </Row>
        <Row>
            {(isFetchingAllPackages) && <Loader />}
            {filteredPackages.length > 0 && viewStyleType.filter(type => type.value === viewStyle)[0].view}
            {isNoResult && <Alert className="mt-3" variant="warning"> Aucune application ne correspond à votre recherche</Alert>}
            {isNoPackage && <Alert className="mt-3" variant="warning">Vous n'avez accès à aucune application</Alert>}
        </Row>
    </Container>;
}

export default PackagePage;